<script>
import Titre from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import StickyFooter from "@/components/molecules/sticky-footer";
import EtatPanierItemList from "@/components/organisms/etat-panier/etat-panier-item-list/mobile";
import { etatPanierActualiseProps } from "./mixin";
import { useEtatPanier } from "../mixin";

export default {
  name: "EtatPanierActualise",
  components: {
    Titre,
    Button,
    Icon,
    Badge,
    Divider,
    StickyFooter,
    EtatPanierItemList
  },
  props: {
    ...etatPanierActualiseProps()
  },
  emits: ["ignore"],
  setup(props) {
    const { status, dateLastUpdate } = useEtatPanier(props.etatPanier);
    return { status, dateLastUpdate };
  }
};
</script>

<template>
  <div class="u-text-center u-flex u-flex-column u-full-height">
    <div class="u-flex-grow">
      <div
        v-if="(!quantiteInsuffisante || quantiteInsuffisante.length === 0) && (!indisponibles || indisponibles.length === 0)"
        class="c-popin-panier-actualise__status"
      >
        <Icon
          name="refresh"
          size="xlg"
        />
        <Badge
          size="sm"
          variant="success"
          circle
          class="c-popin-panier-actualise__status-check"
        >
          <Icon
            name="check"
            size="xlg"
            variant="white"
          />
        </Badge>
      </div>
      <Titre
        tag="h2"
        size="md"
        variant="primary"
        class="u-ml-md@md u-mr-md@md u-text-center u-mb-md u-mx-auto"
      >
        Votre panier a été actualisé
      </Titre>
      <template v-if="quantiteInsuffisante && quantiteInsuffisante.length > 0">
        <div class="u-mt-md">
          <Divider
            class="u-ml-lg@md u-mr-lg@md"
            dotted
          />
          <div class="u-ml-md@md u-mr-md@md u-mt-md">
            <Icon
              name="refresh"
              variant="primary"
              size="lg"
            />
            <p class="u-font-16@md u-font-secondary u-color-primary u-font-18 u-font-700 u-mt-xxs u-mb-sm">
              <template v-if="indisponibles.length === 1">
                La quantité de ce produit a été modifiée car le stock n’est pas suffisant
              </template>
              <template v-else>
                La quantité de ces produits a été modifiée car le stock n’est pas suffisant
              </template>
            </p>
          </div>
        </div>
        <div class="u-ml-md@md u-mr-md@md u-mb-lg">
          <EtatPanierItemList
            :produits="quantiteInsuffisante"
            show-quantite-insuffisante
          />
        </div>
      </template>
      <template v-if="indisponibles && indisponibles.length > 0">
        <div class="u-mt-md">
          <Divider
            class="u-ml-lg@md u-mr-lg@md"
            dotted
          />

          <div class="u-ml-md@md u-mr-md@md u-mt-md">
            <Icon
              name="trash"
              variant="primary"
              size="lg"
            />
            <p class="u-font-16@md u-font-secondary u-color-primary u-font-18 u-font-700 u-mt-xxs u-mb-sm">
              <template v-if="indisponibles.length === 1">
                Ce produit a été supprimé car il n'est plus disponible
              </template>
              <template v-else>
                Ces produits ont été supprimés car ils ne sont plus disponibles
              </template>
            </p>
          </div>
        </div>
        <div class="u-ml-md@md u-mr-md@md u-mb-lg">
          <EtatPanierItemList
            :produits="indisponibles"
            show-similaires
          />
        </div>
      </template>
    </div>
    <StickyFooter :in-dom="false">
      <Button
        outline
        variant="primary"
        size="md"
        radius="full"
        class="u-mt-xs"
        @click="$emit('ignore')"
      >
        Ok, j'ai compris
      </Button>
    </StickyFooter>
  </div>
</template>

<style lang="scss" scoped>
.c-popin-panier-actualise__status {
  position: relative;
  display: inline-block;
}
.c-popin-panier-actualise__status-check {
  position: absolute;
  bottom: 6px;
  right: 2px;
}
</style>
